import { useState } from 'react';

/**
 * Text in die Zwischenablage legen, mit Rückmeldung am Knopf.
 *
 * Die Zwischenablage-Schnittstelle gibt es nur im sicheren Kontext. Im
 * Webview der App ist das gegeben (https://localhost), im Browser über
 * HTTPS ebenfalls — nur bei reinem HTTP fehlt sie. Dafür der Rückfall über
 * ein unsichtbares Textfeld.
 */
export default function KopierKnopf({ text, label = 'Kopieren', title, klasse = 'btn btn--ghost btn--klein' }) {
  const [kopiert, setKopiert] = useState(false);
  const [fehler, setFehler] = useState(false);

  const kopieren = async () => {
    setFehler(false);
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const feld = document.createElement('textarea');
        feld.value = text;
        feld.setAttribute('readonly', '');
        feld.style.position = 'fixed';
        feld.style.opacity = '0';
        document.body.appendChild(feld);
        feld.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(feld);
        if (!ok) throw new Error('Kopieren nicht möglich');
      }
      setKopiert(true);
      setTimeout(() => setKopiert(false), 2000);
    } catch {
      setFehler(true);
      setTimeout(() => setFehler(false), 3000);
    }
  };

  return (
    <button type="button" className={klasse} onClick={kopieren} title={title} disabled={!text}>
      {fehler ? 'Ging nicht' : kopiert ? 'Kopiert' : label}
    </button>
  );
}
